// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__MoU2V","theme-light":"Badge_theme-light__rMgRb","Verified":"Badge_Verified__LL4lv","theme-dark":"Badge_theme-dark__+4J+A"};